export default "__VITE_ASSET__DSngrY7f__"